// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Nra6","label":"SetPasswdForm_label__1Kl5D"};